import { DiffEditor } from '@monaco-editor/react';
import React, { useEffect, useState } from 'react';
import { useAggregatedRule } from '@app/sdk';

export function PreViewChanges({
  selectedOuId,
  selectedCategoryId,
  categories,
  newConfig,
  type,
}: {
  selectedOuId: string;
  newConfig: object;
  selectedCategoryId: string;
  categories: any[];
  type: 'product' | 'merchant';
}) {
  const { data: aggregatedConfigRule } = useAggregatedRule({ ouId: selectedOuId, category: type });
  const [originalConfig, setOriginalConfig] = useState({});
  useEffect(() => {
    if (aggregatedConfigRule && selectedCategoryId && categories) {
      const category = categories.find((x) => x.id === selectedCategoryId);
      const config = {};
      if (category) {
        config[category.name] = aggregatedConfigRule[category.name];
        setOriginalConfig(config);
      }
    }
  }, [aggregatedConfigRule, categories, selectedCategoryId]);
  return (
    <DiffEditor
      height={'365px'}
      key={selectedOuId}
      options={{ readOnly: true }}
      original={JSON.stringify(originalConfig, null, 4)}
      modified={JSON.stringify(newConfig, null, 4)}
      language={'json'}
    />
  );
}
